import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_helpers";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import WifiTetheringIcon from '@material-ui/icons/WifiTethering';
import PortableWifiOffIcon from '@material-ui/icons/PortableWifiOff';

export const ObjectSCssClasses = ["danger", "success"];
export const ObjectSTitles = [
  "MODULES.GENERAL.NONSELECTED",
  "MODULES.GENERAL.SELECTED",
];

export const ObjectIcons = [
  <PortableWifiOffIcon />,
  <WifiTetheringIcon />,
];

export const ConnectionColumnFormatter = (cellContent, row) => (

  <span

    className={`text-${ObjectSCssClasses[(+row.isConnected)]}`}
  >
    {/* <FormattedMessage id={ObjectSTitles[(+row.isConnected)]} /> */}
    {/* <FiberManualRecordIcon /> */}
    {ObjectIcons[(+row.isConnected)]}
  </span>
);
